import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faUserAlt,
    faPencil,
    faHeadset,
    faEnvelope,
    faGlobe,
    faCogs,
    faMobile,
    faUserGroup,
} from '@fortawesome/free-solid-svg-icons';
import { faTelegram, faWhatsapp } from '@fortawesome/free-brands-svg-icons';

const iconMap = {
    default: faUserAlt,
    product_support: faHeadset,
    email: faEnvelope,
    telegram: faTelegram,
    whatsapp: faWhatsapp,
    teams: faUserGroup,
    web: faGlobe,
    custom: faCogs,
    application: faMobile,
};

// Helper to get display name
const getDisplayName = (chatObject, user) => {
    const { interface: iface, username } = chatObject;
    const baseName = username || user.username;

    // Keyed by the RAW interface strings (matching the stored `interface` values),
    // NOT by InterfaceType.* — a stale/missing enum value would otherwise collapse
    // to an "undefined" key and silently break the label (e.g. WhatsApp → email).
    const interfaceLabels = {
        product_support: 'Via Product Support',
        email: `Via Email`,
        telegram: `Via Telegram`,
        whatsapp: `Via WhatsApp`,
        teams: `${baseName} (Via Teams)`,
        api: `Via API`,
        default: baseName,
    };

    return interfaceLabels[iface] || baseName;
};

export const QuestionActionView = ({
    user,
    chatObject,
    setQuery,
    setAttachmentsList,
}) => {
    const icon = iconMap[chatObject.interface] ?? faUserAlt;
    const handleEditClick = () => {
        // Set the question
        setQuery(chatObject.question);

        // Set attachments only if there are any
        if (
            Array.isArray(chatObject?.attachments) &&
            chatObject.attachments.length > 0
        ) {
            setAttachmentsList(chatObject.attachments);
        } else {
            // Optionally clear attachments if none
            setAttachmentsList([]);
        }
    };
    return (
        <div className='w-full ml-auto flex justify-between items-center border-b border-white pb-2 mb-2'>
            <div className='flex items-center justify-between text-texts-secondary300 truncate'>
                <div className='flex items-center justify-center w-6 h-6 rounded-full bg-backgrounds-white mr-2'>
                    <FontAwesomeIcon
                        icon={icon}
                        className='text-texts-tertiary300'
                    />
                </div>
                <div className='font-semibold truncate text-base'>
                    {getDisplayName(chatObject, user)}
                </div>
            </div>
            {/* Action Section */}
            <div className='text-texts-secondary300'>
                <button
                    onClick={handleEditClick}
                    title='Edit the question in chat box'
                    className='ml-4 hover:scale-110'
                >
                    <FontAwesomeIcon icon={faPencil} />
                </button>
            </div>
        </div>
    );
};
